import { useLocation, useNavigate } from 'react-router-dom';
import seo, { services } from '../data';
import Analytics from '../utils/Analytics';
import { useEffect } from 'react';
export default function ServicesPage() {
	const navigate = useNavigate();
	const location = useLocation();
	const contactLink = {
		name: 'Contact',
		onClick: (e) => {
			e.preventDefault();
			if (location.pathname === '/') {
				document
					.getElementById('contact')
					?.scrollIntoView({ behavior: 'smooth' });
			} else {
				navigate('/#contact');
				setTimeout(() => {
					document
						.getElementById('contact')
						?.scrollIntoView({ behavior: 'smooth' });
				}, 500);
			}
		},
	};

	useEffect(() => {
		Analytics.pageViewEvent('Services');
	}, []);
	return (
		<div className='bg-white py-24 sm:py-32'>
			<div className='mx-auto max-w-7xl px-6 lg:px-8'>
				<div className='mx-auto max-w-2xl lg:text-center'>
					<p className='mt-2 text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl lg:text-balance'>
						Services
					</p>
					<p className='mt-6 text-lg/8 text-gray-600'>{seo.site.description}</p>

					<button
						onClick={contactLink.onClick}
						className='bg-primary-600 hover:bg-primary-500 text-white font-semibold px-4 py-2 mt-6 rounded-lg shadow-sm'
					>
						Contact Us
					</button>
				</div>
				<div className='mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-4xl'>
					<dl className='grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16'>
						{services.map((feature) => (
							<div
								key={feature.name}
								className='relative pl-16'
							>
								<dt className='text-base/7 font-semibold text-gray-900'>
									<div className='absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-primary-600'>
										<feature.icon
											aria-hidden='true'
											className='h-6 w-6 text-white'
										/>
									</div>
									{feature.name}
								</dt>
								<dd className='mt-2 text-base/7 text-gray-600'>
									{feature.description}
								</dd>
							</div>
						))}
					</dl>
				</div>
			</div>
		</div>
	);
}
